import React from 'react';
import PropTypes from 'prop-types';
import { priorAuthorizationReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const PADeniedReviewContent = ({ priorAuthorizationReferralDetails, status }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details (Prior Authorization)</strong>

                <div>Status: {status}</div>
                <div>Denial Reason: {priorAuthorizationReferralDetails.denialReason?.name || '--'}</div>
                <div>
                    Create an Appeal Activity:{' '}
                    {priorAuthorizationReferralDetails.isPrescriberSubmittingAppeal?.name || '--'}
                </div>
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{priorAuthorizationReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

PADeniedReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    priorAuthorizationReferralDetails: priorAuthorizationReferralDetailsPropType.isRequired,
};

export default PADeniedReviewContent;
